import { Children, Dispatch, SetStateAction, useEffect, useState } from 'react'
import { LanguageTranslate } from '../../../../shared/Infraestructure/LanguageTranslate'
import { DtoTrabajosDE } from '../../Lista/Domain/DtoTrabajosDE'
import { iDtoHomePassValorizacion } from '../../DocHP/Domain/iDtoHomePassValorizacion'
import { DtoValorizacion } from '../../../Trabajos/Asignacion/Domain/DtoValorizacion'
import { FormikState } from 'formik'
import { DtoInitialValues } from '../../Shared'
import { Modal } from 'react-bootstrap'

interface iProps {
  trabajo: DtoTrabajosDE | null
  setValRechazadaXMetraje: Dispatch<SetStateAction<DtoValorizacion | null>>
  valRechazadaXMetraje: DtoValorizacion | null
  resetForm: (nextState?: Partial<FormikState<DtoInitialValues>> | undefined) => void
}

export const Valorizaciones = (props: iProps) => {

  const { trabajo, setValRechazadaXMetraje, valRechazadaXMetraje, resetForm } = props
  const langTranslate = LanguageTranslate()
  const [show, setShow] = useState(false)
  const [data, setData] = useState<iDtoHomePassValorizacion[]>([])
  const [row, setRow] = useState<iDtoHomePassValorizacion | null>(null)

  useEffect(() => {
    if (!trabajo) return
    const data = trabajo.Ultima_PreLiquidacion.Valorizacion
      .flatMap((curr) =>
        curr.HomePass.filter((e) =>
          e.ClientType === 'Troncal' &&
          [
            'RECHAZADA POR METRAJE'
          ].includes(curr.Ultimo_Estado_Interno.Descripcion)
        ).map(e => ({
          ...e,
          valorizacion: curr
        }))
      )
    setData(data)
  }, [trabajo])

  const handleRowClick = (row: iDtoHomePassValorizacion) => {
    setRow(row)
    setShow(true)
  }

  if (!data.length) return null

  return (
    <>
      <table className='table table-striped' style={{ backgroundColor: 'gray' }}>
        <thead>
          <tr>
            <th scope='col'>ID</th>
            <th scope='col'>{langTranslate.general.Descripcion}</th>
            <th scope='col' className='text-center'>{langTranslate.general.Cantidad}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            Children.toArray(
              data.map(e =>
                <tr>
                  <td onClick={() => handleRowClick(e)}>{e.valorizacion.ID_Valorizacion}</td>
                  <td onClick={() => handleRowClick(e)}>{`${e.valorizacion.DetalleChile.ManoObra.Codigo} ${e.valorizacion.DetalleChile.ManoObra.Nombre}`}</td>
                  <td className='text-center' onClick={() => handleRowClick(e)}>{e.valorizacion.Cantidad.toFixed(2)}</td>
                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    {
                      (
                        ['RECHAZADA POR METRAJE']
                          .includes(e.valorizacion.Ultimo_Estado_Interno.Descripcion) &&
                        e.valorizacion.Semana === 0
                      )
                        ? <input
                          type='radio'
                          name='seleccion'
                          checked={valRechazadaXMetraje?.ID_Valorizacion === e.valorizacion.ID_Valorizacion}
                          onChange={() => {
                            if (setValRechazadaXMetraje)
                              setValRechazadaXMetraje(e.valorizacion)
                            resetForm()
                          }}
                        />
                        : null
                    }
                  </td>
                </tr>
              )
            )
          }
        </tbody>
      </table>
      {
        row && show && (
          <ModalDirecccionInfo show={show} setShow={() => setShow(false)} row={row} />
        )
      }
    </>
  )
}

function ModalDirecccionInfo({ show, setShow, row }: { show: boolean, setShow: (value: boolean) => void, row: iDtoHomePassValorizacion }) {

  const handleClose = () => setShow(false);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title style={{ color: 'white' }}>Dirección</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {`${row.StreetName} ${row.HouseNumber}`}
      </Modal.Body>
    </Modal>
  )
}
